module.exports = {
  GuideTagDisplay: {
    PluginName: "Screen Training Tag Display",
    Tag: "Tag",
    tagRef: "Tag reference",
  },
};
